import { useSelector } from 'react-redux';

import {
  getDynamicFormSelector,
  getDynamicFormSignatureConfigSelector,
} from 'store/selectors/requestFormProcess';
import { UserRoles } from '../UserRoles';
import { DownloadFilesWidget } from './DownloadFilesWidget';
import { dynamicManager } from 'pages/FormProcess/DynamicForm/DynamicManager';
import { CommentBadgeWidget } from './CommentBadgeWidget';
import { Fragment } from 'react';

export const SignatureWidgets = ({ allDocuments, isShowMobileSigningHeader = false }) => {
  const { showUserRoles } = useSelector(getDynamicFormSignatureConfigSelector);

  const isSignScreen = dynamicManager.isSignScreen();

  return (
    <Fragment>
      {showUserRoles && <UserRoles />}

      {dynamicManager.canShowCommentBadge() && isSignScreen && <CommentBadgeWidget />}

      {isSignScreen && !isShowMobileSigningHeader && (
        <DownloadFilesWidget
          documents={allDocuments}
          formProcessPublicId={dynamicManager.getFormProcessPublicId()}
          anonymousUserDetails={dynamicManager.getAnonymousDetails()}
        />
      )}
    </Fragment>
  );
};
